import React from 'react';
export function GuaranteeSection() {
  return <section className="py-16 bg-brand-gold/5 relative overflow-hidden" data-id="element-92">
      <div className="container mx-auto px-4 max-w-4xl relative z-10 text-center" data-id="element-93">
        <img src="https://i.postimg.cc/gjWq162N/selo-garantia-png-2.webp" alt="Garantía de 7 Días" className="mx-auto h-32 mb-8 drop-shadow-[0_0_20px_rgba(212,175,55,0.4)]" data-id="element-94" />
        <h2 className="font-heading text-3xl font-bold text-white mb-6" data-id="element-95">
          Tu Riesgo es Cero Absoluto
        </h2>
        <p className="text-lg text-gray-300 font-light leading-relaxed max-w-2xl mx-auto mb-6" data-id="element-96">
          Descarga el Protocolo Maestro hoy. Aplica el tónico de jengibre. Si en
          los próximos <strong className="text-brand-gold" data-id="element-97">7 días</strong> no
          notas una reducción drástica en los cabellos que dejas en la almohada
          o en la ducha...
        </p>
        <p className="text-xl text-white font-medium italic" data-id="element-98">
          Te devuelvo tu dinero. Sin preguntas, sin resentimientos, sin letras
          pequeñas. Confío tanto en este mecanismo que asumo todo el riesgo.
        </p>
      </div>
    </section>;
}